import useDefinedContext from "hooks/useDefinedContext";
import { createContext } from "react";
import type { LoadVelocityProfile } from "types/load-velocity-profile";

export interface ChartProfileSelectContextType {
  value: LoadVelocityProfile[];
  onChange(profiles: LoadVelocityProfile[]): void;
  options: LoadVelocityProfile[];
}

const ChartProfileSelectContext = createContext<ChartProfileSelectContextType | undefined>(undefined);
ChartProfileSelectContext.displayName = "ChartProfileSelectContext";

export function useChartProfileSelectContext() {
  return useDefinedContext(ChartProfileSelectContext);
}

export default ChartProfileSelectContext;
